import { ReactElement, useState } from 'react';
import Header from './Header';
import Button from '../controls/Button';
import ButtonGroup from '../controls/ButtonGroup';

/**
 * Alert page renders list of alerts.
 * @returns - ReactElement.
 */
function Alert(): ReactElement {
  return <div className="text-gray-400 text-sm mt-5">No alert to show!</div>;
}

/**
 * Notes page renders list of Notes.
 * @returns - ReactElement.
 */
function Notes(): ReactElement {
  return <div className="text-gray-400 text-sm mt-5">No note to show!</div>;
}

type ActivityAttributes = {
  id: number;
  activityName: string;
  timeOfActivity: string;
};

const ACTIVITIES: ActivityAttributes[] = [];

/**
 * A component which renders list of Activity.
 * @returns - Activity Component.
 */
function Activity(): ReactElement {
  return (
    <>
      {ACTIVITIES.length === 0 && (
        <div className="text-gray-400 text-sm mt-5">No activity to show!</div>
      )}
      {ACTIVITIES.map((currentActivity) => {
        return (
          <div key={currentActivity.id} className="flex py-2">
            <div className="rounded-full h-8 w-8 border border-gray-400 dark:border-background-400" />
            <div className=" text-gray-400 dark:text-gray-300 text-sm font-medium ml-4">
              {currentActivity.activityName}
              <p className="text-gray-400 dark:text-gray-400 font-normal text-xs text-start">
                {currentActivity.timeOfActivity}
              </p>
            </div>
          </div>
        );
      })}
    </>
  );
}

const TABS = [
  { id: 'all-activity', name: 'All Activity' },
  { id: 'alerts', name: 'Alerts' },
  { id: 'notes', name: 'Notes' }
];

/**
 * A DevicesActivity Component renders All the different Tabs.
 * @returns - DevicesActivity Component.
 */
export default function DevicesActivity(): ReactElement {
  const [activeTab, setActiveTab] = useState('all-activity');
  return (
    <div className="rounded bg-white dark:bg-container-500 shadow-md p-4 text-center w-full">
      <Header sectionName="Devices Activity" />
      <div className="mt-4">
        <ButtonGroup buttons={TABS} size="sm" handleClick={setActiveTab} activeButton={activeTab} />
      </div>
      <div className="my-4">
        {activeTab === 'all-activity' && <Activity />}
        {activeTab === 'alerts' && <Alert />}
        {activeTab === 'notes' && <Notes />}
      </div>
      {activeTab === 'notes' && <Button theme="secondary-color" size="sm" name="Add Notes" />}
    </div>
  );
}
